import { createContext, Dispatch, SetStateAction } from 'react';

export const hasFocusContext = createContext<[boolean, Dispatch<SetStateAction<boolean>>]>([
  false,
  () => {
    throw new Error('not in focus context');
  },
]);
